// directives.js
export const stylePro = {
  bind (el, binding) {
    let styles = binding.value;
    if (!styles) return;
    if (Array.isArray(styles)) {
      styles = styles.reduce((acc, obj) => ({ ...acc, ...obj }), {});
    }
    for (let property in styles) {
      el.style[property] = styles[property];
    }
  },
  update (el, binding) {
    let styles = binding.value;
    if (!styles) return;
    if (Array.isArray(styles)) {
      styles = styles.reduce((acc, obj) => ({ ...acc, ...obj }), {});
    }
    for (let property in styles) {
      el.style[property] = styles[property];
    }
  },
};

export const byteLimit = {
  bind (el, binding) {
    const maxBytes = binding.value;
    let isComposing = false; // 标记是否在IME组合输入中

    // 计算UTF-8字节长度（兼容不支持TextEncoder的环境）
    const getByteLength = (str) => {
      if (typeof TextEncoder !== 'undefined') {
        return new TextEncoder().encode(str).length;
      }
      // 降级方案：手动计算字节
      let bytes = 0;
      for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);
        if (code <= 0x7f) {
          bytes += 1;
        } else if (code <= 0x7ff) {
          bytes += 2;
        } else if (code <= 0xffff) {
          bytes += 3;
        } else {
          bytes += 4;
        }
      }
      return bytes;
    };

    // 截断文本至指定字节
    const truncate = (value) => {
      let bytes = getByteLength(value);
      if (bytes <= maxBytes) return value;

      // 降级方案：逐字符截断（确保不拆分多字节字符）
      let truncated = '';
      let currentBytes = 0;
      for (const char of value) {
        const charBytes = getByteLength(char);
        if (currentBytes + charBytes > maxBytes) break;
        truncated += char;
        currentBytes += charBytes;
      }
      return truncated;
    };

    // 处理输入事件
    const handleInput = (event) => {
      if (isComposing) return; // IME组合阶段不处理

      const original = event.target.value;
      const truncated = truncate(original);
      if (truncated !== original) {
        event.target.value = truncated;
        event.target.dispatchEvent(new Event('input')); // 触发v-model更新
      }
    };

    // 监听IME事件
    const handleCompositionStart = () => {
      isComposing = true;
    };
    const handleCompositionEnd = (event) => {
      isComposing = false;
      handleInput(event); // 组合结束后强制检查
    };

    // 绑定事件
    el.addEventListener('input', handleInput);
    el.addEventListener('compositionstart', handleCompositionStart);
    el.addEventListener('compositionend', handleCompositionEnd);

    // 保存清理函数
    el._byteLimitCleanup = () => {
      el.removeEventListener('input', handleInput);
      el.removeEventListener('compositionstart', handleCompositionStart);
      el.removeEventListener('compositionend', handleCompositionEnd);
    };
  },

  unbind (el) {
    if (el._byteLimitCleanup) el._byteLimitCleanup();
  }
}
